import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import Still01 from "../assets/still-01.png";
import Still02 from "../assets/still-02.png";
import Still03 from "../assets/still-03.png";
import Still04 from "../assets/still-04.png";
import Still05 from "../assets/still-05.png";
import Still06 from "../assets/still-06.png";
import { useTranslation } from 'react-i18next'


const TheseProperties = () => {
  const { t, i18n } = useTranslation();
  return (
        <>
           <Swiper
                key={i18n.language}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={20}
                loop={true}
                autoplay={{ delay: 3000 }}
                navigation = {false}
                pagination={{ clickable: true }}
                breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 4 },
                1200: { slidesPerView: 6 },
                }}
                className="trending-top-main-main"
                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            >
                {/* Slide 1 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still01} alt="Hotel International Inn" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel1")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still02} alt="ibis New Delhi" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel2")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still03} alt="Hotel Blue Pearl" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel3")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                {/* Slide 4 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still04} alt="The Ashok" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel4")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                {/* Slide 5 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still05} alt="Hyatt Regency" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel5")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                {/* Slide 6 */}
                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still06} alt="Hyatt Regency" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel6")}</h5>
                    </div>
                </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                <div className="trending-box">
                    <div className="trending-img position-relative">
                        <img src={Still04} alt="Hotel International Inn" />
                        <span className="rating-text">8.5</span>
                        </div>
                        <div className="trending-text">
                        <h5>{t("hotel1")}</h5>
                    </div>
                </div>
                </SwiperSlide>

            </Swiper>
    </>
  )
}

export default TheseProperties